import { useOutletContext } from "react-router";
import styled from "styled-components";

const MarketingMessageContainer = styled.div`
  background-color: #d97706;
  color: white;
  font-size: ${({ canvasScale }) => 22 * canvasScale}px;
  text-align: center;
  font-weight: 600;
  line-height: 1;
`;
export default function EncarteTrialVersionMarketingMessage({
  canvasScale,
  className,
}) {
  const { accountStatus } = useOutletContext();

  return (
    <>
      {accountStatus?.onTrial && (
        <MarketingMessageContainer
          canvasScale={canvasScale}
          className={className}
        >
          Encarte criado no período de teste grátis do sistema gerador de
          encartes OfertasExpress. Experimente todos os recursos e gere encartes
          profissionais para sua loja. Crie sua conta e aproveite o período de
          teste grátis.
        </MarketingMessageContainer>
      )}
    </>
  );
}
